<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">

        <!-- Hero banner -->
        <div class="card bg-gradient-primary overflow-hidden mb-4">
          <div class="card-body position-relative py-4">
            <span class="hero-glow"></span>
            <div class="row align-items-center position-relative">
              <div class="col-auto">
                <div class="icon icon-shape icon-lg bg-white shadow text-center border-radius-lg">
                  <i class="ni ni-badge text-dark opacity-10" aria-hidden="true"></i>
                </div>
              </div>
              <div class="col">
                <h5 class="text-white mb-0">Manage Cuti Karyawan</h5>
                <p class="text-white text-sm opacity-8 mb-0">
                  Kuota cuti tahunan per karyawan, dihitung otomatis dari tanggal masuk kerja (ulang tahun periode-nya mengikuti anniversary masing-masing).
                </p>
              </div>
            </div>

            <div class="row mt-4 position-relative">
              <div class="col-6 col-md-3">
                <div class="hero-stat">
                  <span class="hero-stat-label">Total Karyawan</span>
                  <span class="hero-stat-value">{{ table.data.length }}</span>
                </div>
              </div>
              <div class="col-6 col-md-3">
                <div class="hero-stat">
                  <span class="hero-stat-label">Sudah Pakai Cuti</span>
                  <span class="hero-stat-value">{{ sudahPakaiCount }}</span>
                </div>
              </div>
              <div class="col-6 col-md-3">
                <div class="hero-stat">
                  <span class="hero-stat-label">Sisa Cuti Menipis</span>
                  <span class="hero-stat-value">{{ menipisCount }}</span>
                </div>
              </div>
              <div class="col-6 col-md-3">
                <div class="hero-stat">
                  <span class="hero-stat-label">Belum Ada Periode</span>
                  <span class="hero-stat-value">{{ belumAdaPeriodeCount }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="row align-items-center pt-4 px-3">
            <div class="col-12 col-md-4">
              <div class="card-header pb-0">
                <p class="text-xs text-secondary mb-0">Klik angka kuota untuk mengubahnya per karyawan.</p>
              </div>
            </div>
            <div class="col-12 col-md-4 text-center">
              <div class="search-wrapper mx-auto mt-3 mt-md-0">
                <i class="fa fa-search search-icon" aria-hidden="true"></i>
                <input
                  type="text"
                  class="form-control search-input"
                  placeholder="Cari nama karyawan..."
                  v-model="search.nama"
                  @input="get()"
                >
              </div>
            </div>
            <div class="col-12 col-md-4"></div>
          </div>

          <div class="card-body px-0 pt-0 pb-2 mt-4">
            <div class="table-responsive p-0 scroll">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr style="background-color: #F0F8FF;">
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">ID Karyawan</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder ps-3">Nama Karyawan</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Tanggal Masuk</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Periode Cuti Berjalan</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Kuota Cuti</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder" style="min-width: 160px;">Pemakaian</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Sisa Cuti</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in table.data" :key="i">
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">{{ row.id_karyawan }}</span>
                    </td>
                    <td class="align-middle ps-3">
                      <div class="d-flex align-items-center">
                        <div class="avatar-initial" :style="{ backgroundColor: avatarColor(row.nama) }">{{ initials(row.nama) }}</div>
                        <div class="ms-2">
                          <h6 class="mb-0 text-sm">{{ row.nama }}</h6>
                          <span class="text-secondary text-xs">{{ row.jabatan }} &middot; {{ row.unit }}</span>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center">
                      <span v-if="row.tgl_masuk" class="text-secondary text-xs font-weight-bold">{{ moment(row.tgl_masuk).locale('id').format('LL') }}</span>
                      <span v-else class="badge badge-sm bg-gradient-warning">Belum Diisi</span>
                    </td>
                    <td class="align-middle text-center">
                      <span v-if="row.periode_awal" class="text-secondary text-xs font-weight-bold">
                        {{ moment(row.periode_awal).locale('id').format('DD MMM YYYY') }} - {{ moment(row.periode_akhir).locale('id').format('DD MMM YYYY') }}
                      </span>
                      <span v-else class="text-secondary text-xs">-</span>
                    </td>
                    <td class="align-middle text-center">
                      <input
                        type="number"
                        min="0"
                        style="width: 70px; text-align: center;"
                        class="form-control form-control-sm d-inline-block"
                        v-model="row.kuota_cuti"
                        @change="updateKuota(row)"
                      >
                    </td>
                    <td class="align-middle">
                      <div class="d-flex align-items-center" v-if="row.tgl_masuk && row.kuota_cuti">
                        <div class="usage-bar flex-grow-1 me-2">
                          <div class="usage-bar-fill" :class="usageBarClass(row)" :style="{ width: usagePercent(row) + '%' }"></div>
                        </div>
                        <span class="text-secondary text-xs font-weight-bold" style="white-space: nowrap;">{{ row.cuti_terpakai }}/{{ row.kuota_cuti }}</span>
                      </div>
                      <span v-else class="text-secondary text-xs">-</span>
                    </td>
                    <td class="align-middle text-center">
                      <span v-if="row.tgl_masuk" class="badge badge-sm" :class="sisaBadgeClass(row.sisa_cuti)">{{ row.sisa_cuti }} Hari</span>
                      <span v-else class="text-secondary text-xs">-</span>
                    </td>
                  </tr>
                  <tr v-if="table.data.length === 0">
                    <td colspan="7" class="text-center text-sm text-secondary py-5">
                      <i class="fa fa-users fa-2x mb-2" aria-hidden="true" style="opacity: 0.4;"></i>
                      <br>Tidak ada data karyawan
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/configs/config';
import Api from '@/helpers/api';
var moment = require('moment');
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import manageCuti from '@/services/manageCuti.service';
import akun from '@/services/akun.service';

const AVATAR_COLORS = ['#C8102E', '#2563EB', '#0D9488', '#9333EA', '#F59E0B', '#16A34A'];

export default {
  name: "manage-cuti-karyawan",
  data() {
    return {
      moment: moment,
      apiUrl: config.apiUrl,
      onLoading: false,
      role: '',
      table: {
        data: []
      },
      search: {
        nama: '',
      },
    };
  },
  computed: {
    sudahPakaiCount() {
      return this.table.data.filter(function(r) { return r.tgl_masuk && r.cuti_terpakai > 0; }).length;
    },
    menipisCount() {
      return this.table.data.filter(function(r) { return r.tgl_masuk && r.sisa_cuti <= 2; }).length;
    },
    belumAdaPeriodeCount() {
      return this.table.data.filter(function(r) { return !r.tgl_masuk; }).length;
    },
  },
  mounted() {
    this.getRole();
    this.get();
  },
  methods: {
    initials(nama) {
      if (!nama) return '?';
      const parts = nama.trim().split(' ');
      return parts.length > 1 ? (parts[0][0] + parts[1][0]).toUpperCase() : parts[0].substring(0, 2).toUpperCase();
    },
    avatarColor(nama) {
      if (!nama) return AVATAR_COLORS[0];
      let hash = 0;
      for (let i = 0; i < nama.length; i++) {
        hash = nama.charCodeAt(i) + ((hash << 5) - hash);
      }
      return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
    },
    usagePercent(row) {
      if (!row.kuota_cuti) return 0;
      return Math.min(100, Math.round((row.cuti_terpakai / row.kuota_cuti) * 100));
    },
    usageBarClass(row) {
      const pct = this.usagePercent(row);
      if (pct >= 90) return 'bg-gradient-danger';
      if (pct >= 60) return 'bg-gradient-warning';
      return 'bg-gradient-success';
    },
    sisaBadgeClass(sisa) {
      if (sisa <= 0) return 'bg-gradient-danger';
      if (sisa <= 2) return 'bg-gradient-warning';
      return 'bg-gradient-success';
    },
    getRole() {
      let context = this;
      Api(context, akun.indexProfile()).onSuccess(function(response) {
          context.role = response.data.data[0].role;
          if (response.data.data[0].role != 'Admin') {
            context.$router.push({ path: '/detail-profile/'+response.data.data[0].employee_id})
          }
      }).onError(function() {
      })
      .call()
    },
    get() {
      let context = this;
      context.onLoading = true;
      Api(context, manageCuti.index({nama: context.search.nama})).onSuccess(function(response) {
          context.table.data = response.data.data;
      }).onError(function() {
      }).onFinish(function() {
          context.onLoading = false;
      })
      .call()
    },
    updateKuota(row) {
      let context = this;
      Api(context, manageCuti.updateKuota(row.id_karyawan, {kuota_cuti: row.kuota_cuti})).onSuccess(function(response) {
          row.cuti_terpakai = response.data.data.cuti_terpakai;
          row.sisa_cuti     = response.data.data.sisa_cuti;
          context.notify('Kuota Cuti Berhasil Diupdate', 'success');
      }).onError(function() {
          context.notify('Kuota Cuti Gagal Diupdate', 'error');
      })
      .call()
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, {
          autoClose: 2000,
        });
      }else{
        toast.error(message, {
          autoClose: 2000,
        });
      }
    },
  }
};
</script>
<style scoped>
.hero-glow {
  position: absolute;
  top: -60px;
  right: -60px;
  width: 220px;
  height: 220px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255,255,255,0.12) 0%, rgba(255,255,255,0) 70%);
  pointer-events: none;
}
.hero-stat {
  display: flex;
  flex-direction: column;
  background: rgba(255,255,255,0.08);
  border-radius: 0.75rem;
  padding: 10px 12px;
  margin-bottom: 8px;
}
.hero-stat-label {
  font-size: 0.65rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: rgba(255,255,255,0.7);
}
.hero-stat-value {
  font-size: 1.1rem;
  font-weight: 700;
  color: #fff;
}
.search-wrapper {
  position: relative;
  max-width: 320px;
}
.search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #8392AB;
  font-size: 0.8rem;
}
.search-input {
  padding-left: 36px;
  border-radius: 999px;
}
.avatar-initial {
  width: 34px;
  height: 34px;
  min-width: 34px;
  border-radius: 10px;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}
.usage-bar {
  height: 6px;
  border-radius: 999px;
  background-color: #F0F2F5;
  overflow: hidden;
}
.usage-bar-fill {
  height: 100%;
  border-radius: 999px;
  transition: width 0.2s ease;
}
.scroll {
  overflow: auto;
  height: 500px;
}
.scroll thead th {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: #F0F8FF;
}
</style>
